import Grid from '@/global/components/ui/Grid'
import { periodicidade } from '@/locales/plan'
import { FormField, FormFieldSelect } from 'global/components/Form'

export function FormPlano() {
    return (
        <Grid container>
            <Grid item xs={12}>
                <FormFieldSelect
                    required
                    name="periodicity"
                    label="Periodicidade"
                    options={Object.entries(periodicidade).map(
                        ([value, label]) => ({ value, label }),
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    required
                    type="number"
                    name="limiteFuncionarios"
                    label="Limite de funcionários"
                    min={0}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    required
                    name="precoReais"
                    label="Preço"
                    options={{
                        numeral: true,
                        numeralDecimalMark: ',',
                        delimiter: '.',
                        numeralDecimalScale: 2,
                        numeralPositiveOnly: true,
                    }}
                    startAdornment={
                        <span className="mt-1 text-sm text-muted-foreground">
                            R$
                        </span>
                    }
                />
            </Grid>
        </Grid>
    )
}
